__turbopack_context__.v({
  "even": "l_c_sa_even",
  "header": "l_c_sa_header",
  "odd": "l_c_sa_odd",
  "root": "l_c_sa_root",
  "sizeCell": "l_c_sa_sizeCell",
  "sizingTable": "l_c_sa_sizingTable",
  "subtitle": "l_c_sa_subtitle",
  "tableContainer": "l_c_sa_tableContainer",
  "title": "l_c_sa_title",
});
